import { useCallback, useEffect, useState } from 'react';
import { DatePicker } from '@adobe/react-spectrum';
import { useDebounce } from '@uidotdev/usehooks';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../state/store';
import { parseDate } from '@internationalized/date';
import moment from 'moment';

interface IFilterSearchDatePickerProps {
  onSearchChange: (params: {}) => void;
  filterParams: any;
  serachedText?: string;
}

const FilterSearchDatePicker: React.FC<IFilterSearchDatePickerProps> = ({
  onSearchChange,
  filterParams,
  serachedText
}) => {
  const selectedApp = useSelector((state: RootState) => state.userWebLayout.selectedAppId);

  const [filterTerm, setFilterTerm] = useState<string>(serachedText ?? '');
  const debouncedFilterTerm = useDebounce(filterTerm || serachedText, 1000);

  useEffect(() => {
    (async () => {
      searchServiceActivities();
    })();
  }, [debouncedFilterTerm]);

  useEffect(() => {
    setFilterTerm('');
  }, [selectedApp]);

  const handleFiltering = async (value: any) => {
    // DatePicker gives a CalendarDate; store as 'YYYY-MM-DD'
    setFilterTerm(value ? value.toString() : '');
  };

  const searchServiceActivities = useCallback(async () => {
    if (!filterParams.FILTER.COL.some((obj: any) => obj.name === 'contains') && debouncedFilterTerm === '') {
      return;
    }

    const updatedArray = filterParams.FILTER.COL.map((obj: any) =>
      obj.name === 'contains' ? { ...obj, value: filterTerm } : obj
    );

    const hasNameSearch = filterParams.FILTER.COL.some((obj: any) => obj.name === 'contains');

    if (!hasNameSearch && debouncedFilterTerm) {
      updatedArray.push({
        name: 'contains',
        value: debouncedFilterTerm !== '' ? debouncedFilterTerm.toString() : '',
      });
    }

    filterParams.FILTER.COL = updatedArray;
    filterParams.FILTER.COL = filterParams.FILTER.COL.filter((col: any) => col.value !== '');
    onSearchChange(filterParams);
  }, [debouncedFilterTerm]);

  console.log('filterParams on date picker', serachedText);

  // Use filterTerm first; fall back to serachedText; then today.
  const pickerValue = parseDate(
    (filterTerm && filterTerm) ||
      (serachedText && serachedText) ||
      moment(new Date()).format('YYYY-MM-DD')
  );

  return (
    <DatePicker
      width={'100%'}
      onChange={handleFiltering}
      value={pickerValue}
    />
  );
};

export default FilterSearchDatePicker;
